<template>
  <div class="appconfig-nav
    d-none d-lg-block
  ">
    <nav :class="{'customized-affiliate': !!affiliateCustomizations}">
      <ul class="d-flex flex-column ps-0 my-0" data-cy="app-config-nav">
        <!-- Skeleton -->
        <Transition name="fade-drag">
          <li v-if="!navItems || navItems.length === 0" class="position-absolute d-block px-2 py-2">
            <span class="loading-skeleton my-2">
              <span class="d-flex mb-4" v-for="(item, index) in placeholderItems" :key="item.placeholder"
                :class="{
                  'opacity-75': index === 2,
                  'opacity-50': index === 3,
                  'opacity-25': index === 4
                }"
              >
                <span class="load-box skel-300 load-circle rounded-5 me-2">
                  {{ index + 1 }}
                </span>
                <span class="load-box skel-300 px-5 rounded">
                  {{ item.placeholder }}
                </span>
              </span>
            </span>
          </li>
        </Transition>

        <!-- Entries -->
        <TransitionGroup name="fade-drag">
          <li class="d-block" v-for="(item, index) in navItems" :key="item.url">
            <!-- Main-entries -->
            <span :data-cy="`nav${urlToKebab(item.url)}`"
              class="nav-entry position-relative d-block px-1 py-1 border-rounded rounded-2"
              :class="{ 'nav-entry--active': activeRoute === item.url && !(item?.type === 'section') }"
            >
              <AppConfigNavItem
                :active="activeRoute === item.url || activeParent === item.url || activeSectionLabel === item?.label"
                :completed="isNavItemComplete(item) || isNavItemCompleteOptimistic(item)"
                :item="item"
                :index="index"
              />
            </span>

            <!-- Sub-entries -->
            <span
              class="nav-entry nav-entry--sub ms-4 position-relative d-block px-1 py-1 mb-1 border-rounded rounded-2"
              :class="{
                'nav-entry--active': activeRoute === childItem.url
              }"
              v-for="(childItem, childIndex) in item.visibleChildren"
              :key="childItem.name"
            >
              <AppConfigNavItem
                :active="activeRoute === childItem.url"
                :completed="isNavItemComplete(childItem) || isNavItemCompleteOptimistic(childItem)"
                :isSubItem="true"
                :item="childItem"
                :index="childIndex"
              />
            </span>
          </li>
        </TransitionGroup>
      </ul>
    </nav>
  </div>
</template>

<script setup>
import AppConfigNavItem from '~/components/app-config/AppConfigNavItem.vue'

import { useAffiliateCustomizationStore } from '~/store/affiliate-customization';
import { useApplicationConfigStore } from '~/store/application-config'

import { storeToRefs } from 'pinia'

const appConfigStore = useApplicationConfigStore()
const { navItems } = storeToRefs(appConfigStore)
const { affiliateCustomizations } = storeToRefs(useAffiliateCustomizationStore())
const { activeRoute, activeParent, activeSectionLabel,  isNavItemComplete, isNavItemCompleteOptimistic } = useNavItem()

const placeholderItems = [
  { placeholder: 'Placeholder 1' },
  { placeholder: 'Placeholder 2' },
  { placeholder: 'Placeholder 3' },
  { placeholder: 'Placeholder 4' },
  { placeholder: 'Placeholder 5' },
]

const urlToKebab = function(url) {
  if (typeof url !== 'string') {
    return url
  }

  return url.replace(/\//g, '-')
}
</script>

<style lang="scss" scoped>
@import 'assets/styles/affiliate-customizations/affiliate-customizations-sidenav';

.nav-entry {
  transition: background-color 0.5s ease-in-out;
}
.nav-entry--active {
  background: $neutral-300;
}

.fade-drag-enter-active,
.fade-drag-leave-active {
  transition: all 0.15s ease-in-out;
}
.fade-drag-enter-from,
.fade-drag-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.load-box {
  min-width: 25px;
  height: 25px;
}

.appconfig-nav {
  max-width: $sidenav-width;

  z-index: $zindex-fixed;
  background: $neutral-200;
}

.appconfig-nav .customized-affiliate {
  background: $app-aside-background-color;
}
:deep(.customized-affiliate) {
  @include affiliateCustomizedSidenav();
}

</style>
